export default "__VITE_ASSET__2b3eb140__"